var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.58,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#CACDCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.132 31.727s1.433 10.032-.233 12.832c-2.767 3.5-7.366 4.533-13.899 7.7 3.266 7.599 6.766 13.065 10.332 16.631a38.41 38.41 0 0010.066 1.333c4.733 0 9.266-.866 13.432-2.433 3.367-3.7 6.4-8.866 8.933-15.132-10.133-5.766-10.666-5.366-13.2-8.099-1.399-1.5-1.899-5.3-2.132-13.432l-13.299.6z",
    fill: "#9C9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.299 33.027l13.299 1.867c.266 5.6.833 8.432 2 9.666l.1.1c-9.2 2.9-11.864-1.914-15-5.1.034-2.4-.3-5.666-.4-6.533z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.797 22.029c-.433 0-.733.366-.966 1 1.133-19.932-21.532-18.565-20.732-.067-.233-.6-.533-.967-.966-.967-2.7-.233-.134 11.5 1.466 7.9 4.233 13.565 15.699 13.398 19.665-.3 1.133 4.633 4.57-7.6 1.533-7.566z",
    fill: "#9C9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.17 46.152s2.956 5.33 8.612 5.33c7.935 0 9.643-5.051 9.643-5.051l.278-.52s1.866.556 2.714.908c.848.35 8.794 2.483 10.248 6.48 0 0 .69 17.443-21.635 17.443C7.705 70.742 8.335 53.3 8.335 53.3c0-5.693 10.042-6.638 11.835-7.147z",
    fill: "#747779"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.413 37.258s.074 6.175.89 6.778c.498.36 1.843 1.102 2.849 1.631l1.175.615s-13.016 10.432-23.12-.34l2.023-1.28s1.09-1.145 1.006-2.871c-.096-1.726-.096-4.533-.096-4.533h15.273z",
    fill: "#0181A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.043 28.837s-1.461-3.802-1.822-4.406c-.36-.603.276-2.68 0-3.113-.275-.435-.36-6.737 1.822-8.632 2.193-1.896 3.464-2.415 3.464-2.415s.095-.773 2.097-.773c2.012 0 .296-1.292 3.569-.774 3.283.52 3.919.52 3.919.52l.73-.085s2.648 1.038 2.468 2.16c-.18 1.123 2.648 0 2.648 0v.773s2.373.085 2.373 6.048c0 5.74-.445 7.785-1.091 8.113-.657.328-1.367 1.557-1.367 1.557s-6.47 4.523-18.81 1.027z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.102 44.576s2.828 4.035 8.346 4.035c7.732 0 9.384-3.665 9.384-3.665l.329-.54s14.181 3.22 14.181 8.177c0 21.998-46.675 22.21-46.675.053 0-5.423 12.688-7.563 14.435-8.06z",
    fill: "#01496E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.409 44.11c-.032-.02-.074-.053-.106-.074-.826-.603-.89-6.778-.89-6.778H22.141s0 1.79.042 3.124c4.936 6.8 12.604 3.803 16.226 3.728z",
    fill: "#007694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.948 32.638s-.095 5.094 4.66 8.112c4.745 3.019 8.494.52 8.494.52s5.02-3.718 5.116-5.699c.095-1.98.826-2.933.826-2.933s.55 0 .911-.435c.36-.434.455-3.198.73-3.972.276-.773.456-2.075-.455-1.99-.91.084-1.366 1.556-1.366 1.556s.18-2.415-.36-3.971c-.55-1.557.455-5.01-1.737-6.302-2.192-1.293-4.989-.869-6.323-.435-1.345.435-4.173.17-5.91-.434s-3.199 2.245-3.474 3.538c-.275 1.292-1.186 6.566-1.09 7.594l.095 1.038s-.636-2.765-1.187-2.934c-.55-.17-1.557-.17-1.366 1.896.18 2.076.402.466 1.186 4.32.424 2.257 1.25.53 1.25.53z",
    fill: "#0181A1"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.58,
    r: 29,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__b"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.58,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .58)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 1)",
    d: "M0 0h29v27H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.2f5d2eed2f001dbcaf7d101233155104.svg";
export { ForwardRef as ReactComponent };